import { Component } from '@angular/core';

@Component({
  templateUrl: 'editagent3.component.html'
})
export class Editagent3Component {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/agencies/editagent3.component.ts